// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-reviews-block .similar-reviews-title{font-size:var(--font-size-16);line-height:var(--line-height-16);font-family:var(--font-bold);margin-top:var(--space-6);margin-bottom:var(--space-2)}.product-reviews-block .read-more-reviews-button{margin-top:var(--space-6)}.product-reviews-block .no-reviews{text-align:center;margin-top:var(--space-10);margin-bottom:var(--space-10)}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
